





































































































































































import Sign from '@/servers/modules/signinsignup';
import { baseUrl } from '@/utils/axios-request/index';
import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import MyNav from '@/components/skeleton/top.vue'; // 骨架结构顶部
import {
  Upload, Button, Message, Scrollbar, Form, FormItem, Input, Select, Option, DatePicker,
} from 'element-ui';
// 导入 alioss 上传图片
import { OssUpload } from '@/utils/ossUpload';

    @Component({
      components: {
        MyNav,
        Button,
        Scrollbar,
        Form,
        FormItem,
        Input,
        Select,
        Option,
        DatePicker,
        Upload,
      },
    })
export default class MyMaterial extends OssUpload {
        private updateInfoStatus :boolean = false;

        private gradeData : any = [];

        private provinceData : any = [];

        private cityData : any = [];

        private areaData : any = [];

        private isArea : any = false;

        private data:any = {};

        private form:any = {};

        private loading: boolean = false;

        private images: any = '';

        private baseUrl: any = baseUrl;

        private ossUploadBeforeMixins(file) {
          return super.ossUploadBeforeMixins(file);
        }

        private created() {
          this.init();
        }

        private async init() {
          const res = await Sign.queryUpdateUserMes().finally((e) => {

          });

          if (!res.data.code) {
            res.data.data.sexName = res.data.data.sex == '1' ? '男' : '女';
            this.data = this.copyObject(res.data.data);
            this.form = this.copyObject(res.data.data);
          }
        }

        public async updateInfo() {
          // 默认数据禁止通过
          let res:any = { data: { code: 1 } };
          if (this.provinceData.length <= 0 && this.cityData.length <= 0) {
            res = await Sign.queryGradeList().finally((e) => {

            });
            if (!res.data.code) {
              this.gradeData = res.data.data;
            }
            res = await Sign.queryProvence().finally((e) => {

            });

          } else {
            res.data.code = 0;
            res.data.data = this.provinceData;
          }
          if (!res.data.code) {
            this.form.gradeId = Number(this.form.gradeId);
            this.provinceData = res.data.data;

            this.changeProvinceOnce();
            this.updateInfoStatus = true;
          }
        }

        async beforeReadImage(file) {
          this.loading = true;
          await this.fileChange(file, 'image');
        }

        async fileChange(el, type) {
          const isType = el.type.indexOf(type) < 0;
          const isLt2M = el.size / 1024 / 1024 > 50;
          const isImgList = this.images ? this.images.length >= this.limitCount : null;
          if (isLt2M) { this.$toast('上传头文件大小不能超过 50MB!'); }
          if (isType) { this.$toast(`请上传${type}格式的文档`); }
          if (isImgList) { this.$toast(`最多上传2张图片或视频，您已上传${this.images.length}张`); }
          if (isType || isLt2M || isImgList) {
            this.$refs.uploadImage.abort();
            this.loading = false;
            this.abort();
          }
        }

        @Mutation setUserImg:any;

        private async uploadFileSuccess() {
          // 如果调用成功表示上传图片成功 拼接上传成功后的地址
          const response = `${this.uploadUrlMixins}/${this.ossUploadFormDataMixins.key}`;
          this.loading = false;

          const res = await Sign.updateHeaderImg({
            headerImg: response,
          });
          if (res.data.code == 0) {
            this.data.headerUrl = response;
            this.form.headerUrl = response;
            const user = window.LS.get('basicData');
            user.userImg = this.data.headerUrl;
            window.LS.set('basicData', user);
            this.setUserImg();
          }
          // this.images.push(response.data)
        }

        private changeProvinceOnce() {
          this.cityData = [];
          for (let i = 0; i < this.provinceData.length; i++) {
            if (this.provinceData[i].id == this.form.province) {
              this.cityData = this.provinceData[i].childList;
              this.form.city = Number(this.form.city);
              this.form.province = Number(this.form.province);
              this.changeCityOnce();
            }
          }
        }

        private changeCityOnce() {
          this.areaData = [];
          for (let i = 0; i < this.cityData.length; i++) {
            this.isArea = true;
            if (this.cityData[i].id == this.form.city) {
              this.areaData = this.cityData[i].childList;
              this.form.area = Number(this.form.area);
              this.form.city = Number(this.form.city);
            }
          }
        }

        private changeCity() {
          this.areaData = [];
          // this.form.city = null;

          for (let i = 0; i < this.cityData.length; i++) {
            // province 为空 初始化
            if (!this.form.city) {
              this.form.city = this.cityData[i].id;
            }

            if (this.cityData[i].id == this.form.city) {
              this.areaData = this.cityData[i].childList;
              if (this.areaData.length == 0) {
                this.isArea = false;
              } else {
                this.isArea = true;
              //  this.form.area = this.cityData[i].childList[0].id;
              }
              break;
            }
          }
          // 全部转换类型为 number

          // this.form.city = Number(this.form.city);
          this.form.city = Number(this.form.city);
        }

        private changeProvince() {
          this.cityData = [];
          this.form.city = null;
          for (let i = 0; i < this.provinceData.length; i++) {
            if (this.provinceData[i].id == this.form.province) {
              this.cityData = this.provinceData[i].childList;
              this.form.city = this.provinceData[i].childList[0].id;
              break;
            }
          }
          // 全部转换类型为 number
          this.form.city = Number(this.form.city);
          this.form.province = Number(this.form.province);
        }

        private closeUpdateInfo() {
          this.updateInfoStatus = false;
          // 数据还原
          this.form = this.copyObject(this.data);


        }

        private copyObject(scour, tag = {}) {
          for (const i in scour) {
            tag[i] = scour[i];
          }
          return tag;
        }

        private async updateUserInfo() {
          if (!/^1[345678]\d{9}$/.test(this.form.mobileNumberParent)) {
            Message.warning('请输入正确手机号');
            return false;
          }


          const res:any = await Sign.updateUser(this.form).finally((e) => {

          });
          if (!res.data.code) {
            Message.success({ message: '提交成功' });
            this.init();
            this.updateInfoStatus = false;
          }
        }
}
